module.exports = __webpack_public_path__ + "img/green-logo.f9def360.svg";